import {
  Box,
  Button,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import useRequestStore from '../../../store/request';
import { useState } from 'react';

export default function RequestWebhostingInfo({ next, back }) {
  const data = useRequestStore((state) => state.data);
  const [existing, setExisting] = useState(data.website?.existing || true);

  function handleSubmit(evt) {
    evt.preventDefault();
    const formData = new FormData(evt.target);
    const data = Object.fromEntries(formData);
    next({ website: { ...data, existing } });
  }

  function handleBack(evt) {
    const formData = new FormData(evt.target.closest('form'));
    const data = Object.fromEntries(formData);
    back({ website: { ...data, existing } });
  }

  return (
    <Box
      component="form"
      onSubmit={(evt) => handleSubmit(evt)}
      sx={{ display: 'flex', flexFlow: 'column', gap: '16px' }}
    >
      <Typography sx={{ fontSize: '14px', fontStyle: 'italic' }}>
        Ist Ihre Seite bereits online oder in Planung/Entwicklung?
      </Typography>
      <ToggleButtonGroup
        fullWidth
        exclusive
        value={existing}
        onChange={(evt, val) => setExisting(val)}
        sx={{ mt: '-10px' }}
        color="primary"
      >
        <ToggleButton value={true}>Vorhandene Seite</ToggleButton>
        <ToggleButton value={false}>Neue Seite</ToggleButton>
      </ToggleButtonGroup>
      {existing ? (
        <TextField
          label="URL"
          name="url"
          type="url"
          required
          defaultValue={data.website?.url}
        />
      ) : (
        <TextField
          label="Geplante Domain (Adresse)"
          name="domain"
          defaultValue={data.website?.domain}
        />
      )}
      <Button
        type="submit"
        variant="contained"
        sx={{
          borderRadius: 0,
          color: 'white',
          boxShadow: 'none !important',
          '&:hover': {
            backgroundColor: '#19BB5D',
          },
        }}
      >
        Weiter
      </Button>
      <Button
        onClick={handleBack}
        name="back"
        variant="text"
        sx={{ mt: '-8px' }}
      >
        Zurück
      </Button>
    </Box>
  );
}
